import { render, staticRenderFns } from "./DetailPublication.vue?vue&type=template&id=5631ed5b&lang=html"
import script from "./DetailPublication.vue?vue&type=script&lang=js"
export * from "./DetailPublication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports